export default __webpack_public_path__ + "static/media/canvasAndFramed.9b545a5a.png";